import { FolderOpen, Plus, ShieldCheck } from 'lucide-react'

import { Button } from '@/components/ui/button'
import { CopyButton } from '@/components/ui/CopyButton'
import { GeneratedBlankState } from '@/components/ui/generated-blank-state'
import { UploadBlankState } from '@/components/ui/upload-blank-state'
import { Demo, DsSection } from '../primitives'

const noop = () => {}

const UPLOAD_STATES: { prop: string; state: React.ReactNode }[] = [
  {
    prop: '<UploadBlankState addLabel="Add trailer" onAdd={add} onFile={upload} />',
    state: <UploadBlankState addLabel="Add trailer" onAdd={noop} onFile={noop} />,
  },
  {
    prop: 'isLoading',
    state: <UploadBlankState addLabel="Add document" onAdd={noop} onFile={noop} isLoading />,
  },
  {
    prop: 'disabled',
    state: <UploadBlankState addLabel="Add loss run" onAdd={noop} onFile={noop} disabled />,
  },
]

const GENERATED_STATES: { prop: string; state: React.ReactNode }[] = [
  {
    prop: '<GeneratedBlankState icon={ShieldCheck}>{line}</GeneratedBlankState>',
    state: (
      <GeneratedBlankState icon={ShieldCheck}>
        Your insurance will show up here once your coverage starts.
      </GeneratedBlankState>
    ),
  },
  {
    prop: 'action={button}',
    state: (
      <GeneratedBlankState
        icon={FolderOpen}
        action={
          <Button disabled>
            <Plus />
            Report a claim
          </Button>
        }
      >
        Once your coverage starts, you can report a claim here and follow it until it’s settled.
      </GeneratedBlankState>
    ),
  },
]

function Labeled({ value, children }: { value: string; children: React.ReactNode }) {
  return (
    <div className="flex min-w-0 flex-col gap-2">
      <div className="border-ink-100 rounded-sm border">{children}</div>
      <div className="text-ink-400 flex items-center gap-1 font-mono text-[10px]">
        <span>{value}</span>
        <CopyButton
          value={value}
          className="text-ink-400 hover:text-ink size-4 bg-transparent hover:bg-transparent"
        />
      </div>
    </div>
  )
}

export function EmptyStatesSection() {
  return (
    <DsSection id="empty-states" title="Empty states">
      <Demo label="Upload — lists the customer adds to" className="grid gap-8 xl:grid-cols-2">
        {UPLOAD_STATES.map(({ prop, state }) => (
          <Labeled key={prop} value={prop}>
            {state}
          </Labeled>
        ))}
      </Demo>
      <Demo label="Generated — pages Cai fills" className="grid gap-8 xl:grid-cols-2">
        {GENERATED_STATES.map(({ prop, state }) => (
          <Labeled key={prop} value={prop}>
            {state}
          </Labeled>
        ))}
      </Demo>
    </DsSection>
  )
}
